import {
  dataType,
  tsStudyAttribute,
} from '../../../Typescript/StuartPy/StudyAttribute'
import { MenuItem } from '@mui/material'
import { Box } from '@mui/system'
import { Clear } from '@mui/icons-material'

export interface DropdownOption {
  value: string
  label?: string
  listorder: number
}

export function SelectAttributeOptions(field: keyof tsStudyAttribute) {
  switch (field) {
    case 'AttrDatatype':
      return generateMenuItems(
        Object.entries(dataType).map(([key, value], index) => {
          return {
            value: value,
            label: key,
            listorder: index,
          } as DropdownOption
        }),
      )
    default:
      return []
  }
}

export function generateMenuItems(dataList: DropdownOption[], addNull = false) {
  const list = dataList
    .sort((a, b) => (a.listorder < b.listorder ? -1 : 1))
    .map((item) => (
      <MenuItem
        value={item.value}
        key={item.listorder}
      >
        {item.label ? item.label : item.value}
      </MenuItem>
    ))
  if (addNull) {
    return [
      <MenuItem
        value={'null'}
        key={'null'}
      >
        {
          <Box sx={{ display: 'flex' }}>
            <Clear sx={{ mr: 1 / 2 }} />
            Clear
          </Box>
        }
      </MenuItem>,
      ...list,
    ]
  } else {
    return list
  }
}
